/* AHH delivery helper
   Shared by the header pincode box, the product page check and the cart delivery box.
   - Remembers the customer's pincode on this device.
   - Tells Bengaluru local delivery apart from courier delivery.
   - Asks Shopify for the exact courier charge for the current cart. */
(function () {
  'use strict';
  if (window.AHHDelivery) return;

  var KEY = 'ahh_pincode';

  /* Pincodes that get Bengaluru local delivery (delivery fee paid to the delivery person at the door step).
     Everything else is courier delivery. Update this list when the final Local Delivery pincode list is ready. */
  var LOCAL_PREFIXES = ['560'];

  /* First two digits of a pincode -> state. Only used as a hint when Shopify needs a state to find the rate. */
  var STATE_BY_PREFIX = {
    '11': 'Delhi', '12': 'Haryana', '13': 'Haryana', '14': 'Punjab', '15': 'Punjab', '16': 'Punjab',
    '17': 'Himachal Pradesh', '18': 'Jammu and Kashmir', '19': 'Jammu and Kashmir',
    '20': 'Uttar Pradesh', '21': 'Uttar Pradesh', '22': 'Uttar Pradesh', '23': 'Uttar Pradesh', '24': 'Uttar Pradesh',
    '25': 'Uttar Pradesh', '26': 'Uttar Pradesh', '27': 'Uttar Pradesh', '28': 'Uttar Pradesh',
    '30': 'Rajasthan', '31': 'Rajasthan', '32': 'Rajasthan', '33': 'Rajasthan', '34': 'Rajasthan',
    '36': 'Gujarat', '37': 'Gujarat', '38': 'Gujarat', '39': 'Gujarat',
    '40': 'Maharashtra', '41': 'Maharashtra', '42': 'Maharashtra', '43': 'Maharashtra', '44': 'Maharashtra',
    '45': 'Madhya Pradesh', '46': 'Madhya Pradesh', '47': 'Madhya Pradesh', '48': 'Madhya Pradesh', '49': 'Chhattisgarh',
    '50': 'Telangana', '51': 'Andhra Pradesh', '52': 'Andhra Pradesh', '53': 'Andhra Pradesh',
    '56': 'Karnataka', '57': 'Karnataka', '58': 'Karnataka', '59': 'Karnataka',
    '60': 'Tamil Nadu', '61': 'Tamil Nadu', '62': 'Tamil Nadu', '63': 'Tamil Nadu', '64': 'Tamil Nadu',
    '67': 'Kerala', '68': 'Kerala', '69': 'Kerala',
    '70': 'West Bengal', '71': 'West Bengal', '72': 'West Bengal', '73': 'West Bengal', '74': 'West Bengal',
    '75': 'Odisha', '76': 'Odisha', '77': 'Odisha', '78': 'Assam',
    '80': 'Bihar', '81': 'Jharkhand', '82': 'Jharkhand', '83': 'Jharkhand', '84': 'Bihar', '85': 'Bihar'
  };

  function clean(value) {
    return String(value == null ? '' : value).replace(/\D/g, '').slice(0, 6);
  }

  function isValid(pin) {
    return /^[1-9][0-9]{5}$/.test(pin);
  }

  function isLocal(pin) {
    for (var i = 0; i < LOCAL_PREFIXES.length; i++) {
      if (pin.indexOf(LOCAL_PREFIXES[i]) === 0) return true;
    }
    return false;
  }

  function getPin() {
    try {
      var saved = clean(window.localStorage.getItem(KEY));
      return isValid(saved) ? saved : '';
    } catch (error) {
      return '';
    }
  }

  function setPin(pin) {
    try {
      window.localStorage.setItem(KEY, pin);
    } catch (error) {
      /* storage can be blocked; the pincode then only lasts for this page */
    }
    window.AHHDelivery.current = pin;
    document.dispatchEvent(new CustomEvent('ahh:pincode', { detail: { pin: pin } }));
  }

  function describe(pin) {
    if (isLocal(pin)) {
      return {
        type: 'local',
        title: 'Local delivery in Bengaluru',
        lead: 'Pay for your medicines online.',
        body: 'Pay the delivery fee to the delivery person at your door step. We confirm the time and charge before dispatch.'
      };
    }
    return {
      type: 'courier',
      title: 'Courier delivery',
      lead: 'Choose Economy or Express at checkout.',
      body: 'Pay for your medicines and the courier charge online. Courier delivery is not same-day.'
    };
  }

  function formatMoney(value) {
    var number = Number(value);
    if (!isFinite(number)) return String(value);
    var whole = Math.abs(number - Math.round(number)) < 0.005;
    return '₹' + number.toLocaleString('en-IN', {
      minimumFractionDigits: whole ? 0 : 2,
      maximumFractionDigits: whole ? 0 : 2
    });
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function ratesUrl(kind, pin, province) {
    var query =
      'shipping_address%5Bzip%5D=' + encodeURIComponent(pin) +
      '&shipping_address%5Bcountry%5D=India' +
      (province ? '&shipping_address%5Bprovince%5D=' + encodeURIComponent(province) : '');
    return root() + 'cart/' + kind + '.json?' + query;
  }

  function wait(ms) {
    return new Promise(function (resolve) { window.setTimeout(resolve, ms); });
  }

  function requestRates(pin, province) {
    return fetch(ratesUrl('prepare_shipping_rates', pin, province), {
      method: 'POST',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('prepare ' + response.status);
      var attempts = 0;
      function poll() {
        return fetch(ratesUrl('async_shipping_rates', pin, province), { headers: { Accept: 'application/json' } })
          .then(function (res) {
            if (!res.ok && res.status !== 202) throw new Error('async ' + res.status);
            return res.text();
          })
          .then(function (text) {
            var data = null;
            try { data = text ? JSON.parse(text) : null; } catch (error) { data = null; }
            if (data && data.shipping_rates) return data.shipping_rates;
            attempts += 1;
            if (attempts >= 10) throw new Error('timeout');
            return wait(700).then(poll);
          });
      }
      return poll();
    });
  }

  /* Resolves with a list like [{ name, price }] sorted by price, or rejects. */
  function fetchRates(pin) {
    function tidy(list) {
      return (list || [])
        .map(function (rate) {
          return { name: rate.presentment_name || rate.name, price: Number(rate.price) };
        })
        .filter(function (rate) { return rate.name && isFinite(rate.price); })
        .sort(function (a, b) { return a.price - b.price; });
    }
    return requestRates(pin, '')
      .then(tidy)
      .then(function (list) {
        if (list.length) return list;
        var province = STATE_BY_PREFIX[pin.slice(0, 2)];
        if (!province) return list;
        return requestRates(pin, province).then(tidy);
      });
  }

  window.AHHDelivery = {
    current: getPin(),
    clean: clean,
    isValid: isValid,
    isLocal: isLocal,
    getPin: getPin,
    setPin: setPin,
    describe: describe,
    formatMoney: formatMoney,
    fetchRates: fetchRates
  };
})();
